import type { IVRInfo } from "../../../../sales-context/SalesContext.types";
import type { CustomerVerificationStep } from "../../../../stores/useVerificationFlowStore";

export function isIVRHandoffStep({
    stepHistory,
    ivrInfo,
}: {
    stepHistory: CustomerVerificationStep[];
    ivrInfo?: IVRInfo;
}) {
    const isStandardIVRHandoffStep = stepHistory.at(stepHistory.length - 1) === "CustomerPhoneInput";
    const isConversationalIVRHandoffStep =
        !!ivrInfo?.conversationalSummary && stepHistory.at(stepHistory.length - 1) === "CustomerHandoff";
    return (isStandardIVRHandoffStep && hasStandardIVRInfo(ivrInfo)) || isConversationalIVRHandoffStep;
}

export function hasStandardIVRInfo({
    intent,
    device,
    summary,
    productLink,
    productTitle,
    conversationalSummary,
}: IVRInfo = {}): boolean {
    return (!!intent || !!device || !!summary || !!productLink || !!productTitle) && !conversationalSummary;
}
